import React from 'react'
import { PatternFormat } from 'react-number-format'

// `pattern` is what actually enforces the ticket's "10-digit field": the mask
// leaves `_` placeholders behind on a half-typed number, so `required` alone
// would let `(867) 555-01__` through.
const TEN_DIGIT_PATTERN = '\\(\\d{3}\\) \\d{3}-\\d{4}'

const FormatPhoneNumber = ({ fieldName, value, onValueChange, required }) => {
  return (
    <PatternFormat
      name={fieldName}
      format='(###) ###-####'
      mask='_'
      value={value || ''}
      onValueChange={onValueChange}
      required={required}
      pattern={required ? TEN_DIGIT_PATTERN : undefined}
      title={required ? 'Enter a 10-digit phone number, including area code' : undefined}
    />
  )
}

export default FormatPhoneNumber
